// src/components/BlinkingTeeBot.js
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Box } from '@mui/material';

// --- Configuration ---
const EYES_OPEN_SRC = '/teebot_eyesopen.png';
const EYES_CLOSED_SRC = '/teebot_eyesclosed.png';
const BLINK_DURATION_MS = 300; // How long the eyes stay closed (short)
const MIN_TIME_BETWEEN_BLINKS_MS = 5000; // Minimum time eyes are open
const MAX_TIME_BETWEEN_BLINKS_MS = 10000; // Maximum time eyes are open
// --------------------

function BlinkingTeeBot({ sx }) { // Accept sx prop to pass styles
  const [imgSrc, setImgSrc] = useState(EYES_OPEN_SRC);
  const timeoutRef = useRef(null);

  // Function to schedule the next blink - now using useCallback
  const scheduleNextBlink = useCallback(() => {
    // Clear any existing timer
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Calculate random time until the next blink starts
    const timeToNextBlink =
      MIN_TIME_BETWEEN_BLINKS_MS +
      Math.random() * (MAX_TIME_BETWEEN_BLINKS_MS - MIN_TIME_BETWEEN_BLINKS_MS);

    timeoutRef.current = setTimeout(() => {
      // Blink: Close eyes
      setImgSrc(EYES_CLOSED_SRC);

      // Schedule reopening eyes after a short duration
      timeoutRef.current = setTimeout(() => {
        setImgSrc(EYES_OPEN_SRC);
        // Eyes are open again, schedule the *next* blink
        scheduleNextBlink();
      }, BLINK_DURATION_MS);

    }, timeToNextBlink);
  }, []); // Empty dependency array since this function doesn't use any props or state that could change

  useEffect(() => {
    // Start the blinking cycle when the component mounts
    scheduleNextBlink();

    // Cleanup function: Clear the timer when the component unmounts
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [scheduleNextBlink]); // Added scheduleNextBlink to dependency array

  return (
    <Box
      component="img"
      src={imgSrc}
      alt="GolfTeeBot Logo"
      sx={sx} // Apply the styles passed down from App.js
    />
  );
}

export default BlinkingTeeBot;